
import ImageRabo from "../assets/logos/rabobank-logo68x80.webp";
import ImageAbn from "../assets/logos/ABN.png";
import ImagePGGM from "../assets/logos/pggm-logo-zonder-payof_480x480.jpg";
import ImageING from "../assets/logos/ing.png";
import ImageEngie from "../assets/logos/engie.png";
import ImageNS from "../assets/logos/NS.jpeg";
import ImageAchmea from "../assets/logos/achmea-logo.png";
import ImageCIZ from "../assets/logos/CIZ.png";
import ImageSchiphol from "../assets/logos/Schiphol-logo.jpg";


export const CustomerList = [

    {
        id: 1,
        name: "Rabobank",
        img: ImageRabo,

    },
    {
        id: 2,
        name: "ABN-Amro",
        img: ImageAbn,

    },
    {
        id: 3,
        name: "PGGM",
        img: ImagePGGM,

    },
    {
        id: 4,
        name: "ING",
        img: ImageING,

    },
    {
        id: 5,
        name: "Engie",
        img: ImageEngie,

    },
    {
        id: 6,
        name: "NS",
        img: ImageNS,

    },
    {
        id: 7,
        name: "Achmea",
        img: ImageAchmea,

    },
    {
        id: 8,
        name: "CIZ",
        img: ImageCIZ,

    },
    {
        id: 9,
        name: "Schiphol",
        img: ImageSchiphol,

    },

];
